import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BISidebarComponent } from './component/shareModule/bisidebar/bisidebar.component';
import { LoadingComponentComponent } from './component/shareModule/loading-component/loading-component.component';
import { ModalComponent } from './component/shareModule/modal/modal.component';
import { ProgressComponentComponent } from './component/shareModule/progress-component/progress-component.component';
import { ToastComponentComponent } from './component/shareModule/toast-component/toast-component.component';
import { TopNavigationComponent } from './component/shareModule/top-navigation/top-navigation.component';
import { LoginComponent } from './component/userModule/login/login.component';
import { ProfileComponent } from './component/userModule/profile/profile.component';
import { UserAccountComponent } from './component/userModule/user-account/user-account.component';
import { BodyComponent } from './component/shareModule/body/body.component';
import { BodyFullComponent } from './component/shareModule/body-full/body-full.component';
import { PlaceholderComponent } from './component/shareModule/placeholder/placeholder.component';
import { TableActionComponent } from './component/shareModule/table-action/table-action.component';
import { ModalFullComponent } from './component/shareModule/modal-full/modal-full.component';
import { ModalSheetsComponent } from './component/shareModule/modal-sheets/modal-sheets.component';
import { StatusLabelComponent } from './component/shareModule/status-label/status-label.component';
import { TabMenuComponent } from './component/shareModule/tab-menu/tab-menu.component';
import { FormInputComponent } from './component/shareModule/form-input/form-input.component';
import { FormSelectComponent } from './component/shareModule/form-select/form-select.component';
import { FormSearchComponent } from './component/shareModule/form-search/form-search.component';
import { StatusLabelPerformanceComponent } from './component/shareModule/status-label-performance/status-label-performance.component';
import { FormMultipleSelectComponent } from './component/shareModule/form-multiple-select/form-multiple-select.component';
import { TableSortComponent } from './component/shareModule/table-sort/table-sort.component';
import { TooltipsComponent } from './component/shareModule/tooltips/tooltips.component';
import { CardComponent } from './component/shareModule/card/card.component';
import { LazyLoadDirective } from './component/shareModule/lazy-load.directive';
import { ConfirmDialogComponent } from './component/shareModule/confirm-dialog/confirm-dialog.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { TabOptionComponent } from './component/shareModule/tab-option/tab-option.component';
import { HomepageComponent } from './frontend/homepage/homepage.component';
import { SectionFooterComponent } from './frontend/homepage/section-footer/section-footer.component';
import { SeparatorDirective } from './component/shareModule/separator.directive';
import { ServiceComponent } from './frontend/homepage/service/service.component';
import { LocationComponent } from './frontend/homepage/location/location.component';
import { ProsumerComponent } from './frontend/homepage/prosumer/prosumer.component';
import { EnterpriseComponent } from './frontend/homepage/enterprise/enterprise.component';
import { SectionGalleryComponent } from './frontend/homepage/section-gallery/section-gallery.component';
import { HandheldComponent } from './frontend/homepage/handheld/handheld.component';
import { RouterModule,Routes } from '@angular/router';

@NgModule({
  declarations: [
    AppComponent,
    BISidebarComponent,
    TopNavigationComponent,
    ModalComponent,
    ProgressComponentComponent,
    ToastComponentComponent,
    LoadingComponentComponent,
    ProfileComponent,
    LoginComponent,
    UserAccountComponent,
    BodyComponent,
    BodyFullComponent,
    PlaceholderComponent,
    TableActionComponent,
    ModalFullComponent,
    ModalSheetsComponent,
    StatusLabelComponent,
    TabMenuComponent,
    FormInputComponent,
    FormSelectComponent,
    FormSearchComponent,
    StatusLabelPerformanceComponent,
    FormMultipleSelectComponent,
    TableSortComponent,
    TooltipsComponent,
    CardComponent,
    LazyLoadDirective,
    ConfirmDialogComponent,
    DashboardComponent,
    TabOptionComponent,
    HomepageComponent,
    SectionFooterComponent,
    SeparatorDirective,
    ServiceComponent,
    LocationComponent,
    ProsumerComponent,
    EnterpriseComponent,
    SectionGalleryComponent,
    HandheldComponent
    
  

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,


    
  ],
  providers: [
   
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  
 }
